import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter as Router } from "react-router-dom";
import * as serviceWorker from "./serviceWorker";
import configureStore from "./store/configureStore";
import Root from "./containers/Root";
import history from "./utils/history";
import "./index.scss";

const store = configureStore();

ReactDOM.render(
  <Router history={history}>
    <Root store={store} />
  </Router>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
